export const PRIVILEGES = {
  VIEW_FARMER_RECORDS: "View Farmer Records",
  VIEW_SINGLE_FARMER: "View Single Farmer",
  CALL_FARMER: "Call Farmer",
  SEND_MESSAGE: "Send Message",
  GENERATE_ACCOUNT_NUMBER: "Generate Account Number",
  EDIT_PROFILE: "Send Edit Profile",
  CREATE_FARMER_ORDER: "Create Farmer Order",
  GENERATE_STATEMENT: "Generate Statement",
  KYC_DOCUMENTATION: "Kyc Documentation",
  SET_DAILY_LIMIT: "Set Daily Limit",
  GENERATE_PIN: "Generate PIN",
  SUSPEND_FARMER: "Suspend Farmer",
  BLOCK_FARMER: "Block Farmer",
  RESET_BVN: "Reset BVN",
  VIEW_MESSAGE_LOG: "View Message Log",
  COMPOSE_MESSAGE: "Compose Message",
  APPROVE_BULK_MESSAGE: "Approve Bulk Message",
  CREATE_TEMPLATE: "Create Template",
  EDIT_TEMPLATE: "Edit Template",
  DELETE_TEMPLATE: "Delete Template",
  EDIT_COMPLAINT: "Edit Complaint",
  VIEW_COMPLAINTS: "View Complaints",
  VIEW_COOPERATIVE: "View Cooperative",
  CREATE_COOPERATIVE: "Create Cooperative",
  EDIT_COOPERATIVE: "Edit Cooperative",
  APPROVE_COOPERATIVE: "Approve Cooperative",
  DEACTIVATE_COOPERATIVE: "Deactivate Cooperative",
  VIEW_DEBIT_RECORDS: "View Debit Records",
  DEBIT_FARMER: "Debit Farmer",
  BULK_DEBIT: "Bulk Debit",
  VIEW_REQUESTS: "View Requests",
  CHANGE_CALL_STATUS: "Change Call Status",
  VIEW_CALL_TO_ORDERS: "View All Call to Order",
  CREATE_ORDER: "Create Call to Order",
  EDIT_ORDER: "Edit Call to Order",
  SET_CALL_STATUS: "Set Call Status",
  VIEW_ORDERS: "View Orders",
  CONFIRM_ORDER: "Confirm Order",
  REJECT_ORDER: "Reject Order",
  ADD_DELIVERY_INFO: "Add Delivery Info",
  UPDATE_DELIVERY: "Update Delivery",
  CANCEL_ORDER: "Cancel Order",
  ASSIGN_ORDER: "Assign Order",
  VIEW_MY_ASSIGNED_ORDER: "View My Assigned Order",
  REASSIGN_ORDER: "Reassign Order",
  CHANGE_ORDER_STATUS: "Change Order Status",
  ADD_NOTE: "Add Note",
  VIEW_RETAIL_RECORD: "View Retail Record",
  VIEW_CAMPAIGN: "View Campaign",
  EDIT_CAMPAIGN: "Edit Campaign",
  CREATE_CAMPAIGN: "Create Campaign",
  SEARCH_FOR_PRODUCT: "Search for Product",
  ADD_PRODUCT: "Add Product",
  EDIT_PRODUCT: "Edit Product",
  DISABLE_PRODUCT: "Disable Product",
  VIEW_OVERVIEW: "View Overview",
  ADD_TO_STOCK: "Add to Stock",
  EXPORT_DATA: "Export Data",
  CREATE_STORE: "Create Store",
  EDIT_STORE: "Edit Store",
  DISABLE_STORE: "Disable Store",
  VIEW_STORE: "View Store",
  ADD_STORE_MANAGER: "Add Store Manager",
  ADD_STOCK_TO_STORE: "Add Stock to Store",
  REQUEST_NEW_STOCK: "Request New Stock",
  APPROVE_STOCK: "Approve Stock",
  CONFIRM_STOCK: "Confirm Stock",
  ACCEPT_TRANSFER_REQUEST: "Accept Transfer Request",
  UPDATE_STOCK_REQUEST: "Update Stock Request",
  VIEW_USSD_SESSIONS: "View USSD Sessions",
  VIEW_TRANSACTIONS: "View Transactions",
  INVITE_TEAMMATE: "Invite Teammate",
  DISABLE_TEAMMATE: "Disable Teammate",
  VIEW_TEAMMATES: "View Teammates",
  CANCEL_INVITE: "Cancel Invite",
  RESEND_INVITE: "Resend Invite",
  VIEW_INVENTORY: "View Inventory Overview",
  VIEW_LOAN_OVERVIEW: "View Loan Overview",
  VIEW_AGENTS: "View Agents",
};